/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.sherpa.customers.activity.controllers', [])

.controller('SherpaCustomersActivityController', ['$scope', function($scope) {

    $scope.sherpaCustomersActivity = "Your spankin new application.sherpa.customers.activity view!";

}]);